export enum TourType {
  firstTourStarted = "firstTourStarted",
  firstTourFinished = "firstTourFinished",
  secondTourStarted = "secondTourStarted",
  secondTourFinished = "secondTourFinished"
}

export interface Widget {
  munitipalityIds: string;
  regionIds: string;
  tourType: TourType;
  firstOlympId: string;
  secondOlympId: string;
  currentYear: string;
  dateSecondTourEnd: string;
  datesSecondTour: string;

  modalMessage: string;
  orderTitle: string;
  olympiadName: string;

  secondTourSubInfo?: string
}
